module.exports = __webpack_public_path__ + "Icon_Speed Physics@2x.png?539b179ab24ef22e18b21e5c59039461";